export default __webpack_public_path__ + "static/media/icon_unlocked.a1901e98.png";